import angular from 'angular';
import angularScroll from 'angular-scroll';
import dlsNgMemberFooter from '@collectivehealth/dls-ng-member-footer';

const module = angular.module('dls-mx', [angularScroll, dlsNgMemberFooter]);

export default module;
